module.exports = __webpack_public_path__ + "static/media/sound.03210e2d.mp3";